type RoomMode = { usar_mapa_mesas?: boolean | null } | null | undefined;

export const usesTableMap = (room: RoomMode, legacyDefault = true): boolean =>
  typeof room?.usar_mapa_mesas === 'boolean' ? room.usar_mapa_mesas : legacyDefault;
